import { Input } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface ExternalIdProps {}

const ExternalId: FC<ExternalIdProps> = () => {
    const name = 'externalId'

    return (
        <Form.Item name={name} label={'ID Koher'} rules={requiredRules}>
            <Input />
        </Form.Item>
    )
}

export default ExternalId
